import { useEffect } from "react";
import { css } from "@emotion/react";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";

import { fadeInVariants } from "../../constants/animations";

const Original: React.FC = () => {
  const topControls = useAnimation();
  const [topRef, inView] = useInView();
  useEffect(() => {
    if (inView) {
      topControls.start("visible");
    }
  }, [topControls, inView]);

  const bottomControls = useAnimation();
  const [bottomRef, bottomInView] = useInView();
  useEffect(() => {
    if (bottomInView) {
      bottomControls.start("visible");
    }
  }, [bottomControls, bottomInView]);

  const voiceControls = useAnimation();
  const [voiceRef, voiceInView] = useInView();
  useEffect(() => {
    if (voiceInView) {
      voiceControls.start("visible");
    }
  }, [voiceControls, voiceInView]);

  return (
    <div css={mainStyle} id="original">
      <div css={containerStyle}>
        <motion.div
          ref={topRef}
          initial="hidden"
          animate={topControls}
          variants={fadeInVariants}
        >
          <div css={titleStyle}>ORIGINAL</div>
          <div css={contentsTopWrapperStyle}>
            <img
              src={process.env.REACT_APP_BASE_PATH + "/img/book.jpg"}
              css={bookImgStyle()}
            />
            <div css={captionStyle(28, 30, 16, 15)}>
              柚月裕子「朽ちないサクラ」
            </div>
            <div css={captionStyle(16, 10, 12, 6)}>(徳間文庫)</div>
            {/*
            <a
              href="https://www.tokuma.jp/book/b493997.html"
              target="_blank"
              rel="noopener"
              css={css`
                text-decoration: none;
              `}
            >
              <div css={offiicalBtnStyle()}>公式サイト</div>
            </a>
            */}
          </div>
        </motion.div>
        <motion.div
          ref={bottomRef}
          initial="hidden"
          animate={bottomControls}
          variants={fadeInVariants}
        >
          <div css={contentsBottomWrapperStyle}>
            <img
              src={process.env.REACT_APP_BASE_PATH + "/img/book-tsukishita.jpg"}
              css={bookImgStyle(40, 30)}
            />
            <div css={captionStyle(28, 30, 16, 15)}>
              柚月裕子「月下のサクラ」
            </div>
            <div css={captionStyle(16, 10, 12, 6)}>(徳間文庫)</div>
            <a
              href="https://www.tokuma.jp/sakura/"
              target="_blank"
              rel="noopener"
              css={css`
                text-decoration: none;
              `}
            >
              <div css={offiicalBtnStyle("#28485a", "#fff")}>公式サイト</div>
            </a>
            <div css={captionStyle(14, 60, 10, 55)}>
              ©2024 映画「朽ちないサクラ」製作委員会
            </div>
          </div>
        </motion.div>
        <motion.div
          ref={voiceRef}
          initial="hidden"
          animate={voiceControls}
          variants={fadeInVariants}
        >
          <img
            src={process.env.REACT_APP_BASE_PATH + "/img/voice-guide.png"}
            css={voiceImgStyle}
          />
        </motion.div>
      </div>
    </div>
  );
};

const spSize = 768;

const mainStyle = css`
  position: relative;
  width: 100%;
  overflow: hidden;
  background-image: url(${process.env.REACT_APP_BASE_PATH +
  "/img/bg-original-pc.jpeg"});
  background-position: center;
  background-size: cover;

  @media (max-width: ${spSize}px) {
    background-image: url(${process.env.REACT_APP_BASE_PATH +
    "/img/bg-original-sp.jpeg"});
  }
`;

const containerStyle = css`
  width: 100%;
  padding: 40px 0 10px;
  background-color: rgba(41, 73, 91, 0.32);

  @media (max-width: ${spSize}px) {
    padding: 30px 0 10px;
  }
`;

const titleStyle = css`
  font-size: 35px;
  font-weight: 500;
  letter-spacing: 0.075em;

  @media (max-width: ${spSize}px) {
    font-size: 20px;
  }
`;

const contentsTopWrapperStyle = css`
  width: 100%;
  padding-top: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: ${spSize}px) {
    padding-top: 25px;
  }
`;

const contentsBottomWrapperStyle = css`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const bookImgStyle = (marginTop?: number, marginTopSP?: number) => css`
  width: 250px;
  height: auto;
  margin-top: ${marginTop ? marginTop : 0}px;

  @media (max-width: ${spSize}px) {
    width: 200px;
    margin-top: ${marginTopSP ? marginTopSP : 0}px;
  }
`;

const captionStyle = (
  fontSize: number,
  paddingTop: number,
  fontSizeSP: number,
  paddingTopSP: number,
) => css`
  font-size: ${fontSize}px;
  padding-top: ${paddingTop}px;

  @media (max-width: ${spSize}px) {
    font-size: ${fontSizeSP}px;
    padding-top: ${paddingTopSP}px;
  }
`;

const offiicalBtnStyle = (color?: string, bgColor?: string) => css`
  font-size: 18px;
  padding: 10px 20px;
  margin-top: 30px;
  color: ${color ?? "#fff"};
  background-color: ${bgColor ?? "#28485a"};
  display: flex;
  letter-spacing: 0.075em;
  font-weight: 700;

  @media (max-width: ${spSize}px) {
    font-size: 14px;
    padding: 8px 16px;
    margin-top: 20px;
    font-weight: 500;
  }

  &:hover {
    cursor: pointer;
  }
`;

const voiceImgStyle = css`
  margin-top: 40px;
  margin-bottom: 20px;
  width: 80%;
  max-width: 600px;
  height: auto;

  @media (max-width: ${spSize}px) {
    margin-top: 30px;
    margin-bottom: 5px;
  }
`;

export default Original;
